import React, { useEffect } from 'react';
import { useIntl } from 'react-intl';

import { Checkbox, Form, Input } from 'antd';
import FormLabel from 'components/FormLabel';
import messages from './messages';

const toOption = (role) => ({ label: role.name, value: role.id });

const InviteUserForm = ({ form, onSubmit, availableRoles = [] }) => {
  useEffect(() => form.resetFields(), []);
  const { formatMessage: $t } = useIntl();

  const roleOpts = availableRoles.map(toOption);

  return (
    <Form
      layout="vertical"
      form={form}
      onFinish={onSubmit}
    >
      <Form.Item
        name="email"
        label={<FormLabel label={messages.email} />}
        rules={[
          { type: 'email', message: $t(messages.emailInvalid) },
          { required: true, message: $t(messages.emailRequired) },
        ]}
      >
        <Input />
      </Form.Item>
      <Form.Item
        name="roleIds"
        label={<FormLabel label={messages.internalRoles} />}
      >
        <Checkbox.Group options={roleOpts} />
      </Form.Item>
    </Form>
  );
};

export default InviteUserForm;
